<template>
  <div>
    <div class="main-content mt-2">
      <div class="row">
        <div class="container-fluid my-0">
          <div class="">
            <div class="row" v-if="!$route.query.id">
              <div class="col-12">
                <div class="heading">
                  <h1>
                    <span
                      >Create a Power BI theme.<br />
                      by Enterprise DNA…</span
                    >
                  </h1>
                </div>
              </div>
            </div>
            <div class="updated-message-wrapper" v-if="successUpdateMessage">
              <div class="updated-message" style="display: block">
                <p>
                  <img src="/assets/img/checkbox-outline.svg" alt="" />{{
                    successUpdateMessage
                  }}
                </p>
              </div>
            </div>
            <div class="row">
              <div
                class="
                  col-12 col-sm-7 col-lg-9 col-xl-10
                  order-2 order-sm-1
                  mb-5
                "
              >
                <h2>{{ $parent.documentData.name }}</h2>
                <div
                  class="mt-4"
                  v-html="$parent.documentData.description"
                ></div>
                 <user-card
                  v-if="$parent.documentData.user"
                  class="ml-0 mt-2"
                ></user-card>
                <!--<div class="dax-search-code editor-wrapper preview">
                  <div class="dax-search-code-form" v-if="!showResults">
                    <textarea-autosize
                      v-on:keydown.tab.prevent="tabber($event)"
                      class="form-control"
                      v-model="code"
                      :min-height="20"
                      :max-height="800"
                      placeholder="Paste your R Code HERE"
                    />
                  </div>
                  <div class="editor-preview-edit-mode rawcode-snippet">
                    <prism
                      class="line-numbers"
                      :plugins="['line-numbers']"
                      :code="code"
                      style="max-height: 545px"
                      v-if="showResults"
                    ></prism>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-edited-btn" v-if="code" v-cloak>
      <div class="btn-edit-left">
        <!-- <button
          @click="showResults = !showResults"
          v-if="showResults && !readOnly"
          class="btn btn-edit-rawcode"
        >
          EDIT
        </button> -->
        <router-link
          class="btn btn-edit-rawcode"
          :to="{
            name: 'PowerBiThemes',
            query: { id: $route.query.id },
          }"
          >EDIT</router-link
        >
        <router-link
          class="btn btn-primary"
          :to="{
            name: 'PowerBiThemes',
          }"
          >NEW</router-link
        >
        <!-- <a
          @click="newDoc()"
          v-if="code && onceFormatted && showResults"
          class="btn btn-primary"
          >NEW</a
        >
        <button
          @click="showResults = !showResults"
          v-if="!showResults && code"
          class="btn btn-outline-primary delete-document-popup"
        >
          COMMIT
        </button> -->
      </div>
      <!-- <div class="btn-copy-right">
        <button
          @click="updateDocument()"
          v-if="edit && !readOnly"
          class="btn btn-outline-primary save-document-popup"
        >
          {{ updateBtnText }}
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import DaxHttpService from "../services/DaxHttpService";
import sqlFormatter from "sql-formatter";
import sqlFormatter2 from "../util/sql-formatter";
import DaxFormula from "./partials/DaxFormula";
import UserCard from "./partials/UserCard";
import Prism from "vue-prismjs";
import Avatar from "vue-avatar";

export default {
  name: "PowerBi",
  props: ["docData"],
  components: {
    DaxFormula,
    UserCard,
    Prism,
    Avatar,
  },
  data: function () {
    return {
      document: null,
      code: null,
      settings: {
        setting_title: {
          automatic: true,
          comma: false,
          semicolon: false,
        },
        spacing: {
          best_practice: true,
          space_after_function: false,
        },
        lines: {
          long_lines: false,
          short_lines: true,
        },
      },

      showResults: false,

      edit: false,
      readOnly: false,

      copyCodeBtnText: "COPY CODE",
      updateBtnText: "UPDATE",

      lookUpFormula: false,

      searchResult: "",
      onceFormatted: false,
      successUpdateMessage: "",
    };
  },
  mounted() {
    // load document id if exists
    this.code = this.docData.entity_data.path;
    
    if (this.$route.query.id) {
      this.loadDocument();
      this.onceFormatted = true;
      this.edit = true;
    }

    let localData = localStorage.getItem("temp_app_data");
    if (localData) {
      localData = JSON.parse(localData);
      this.code = localData.entity_data.path;
      this.settings = localData.entity_data.settings;

      localStorage.removeItem("temp_app_data");
    }

    // clone
    
    if (this.$route.query.clone && this.docData) {
      this.clone();
    }
  },

  methods: {
    showSettings() {
      if (this.$refs.daxRef.offsetParent === null) {
        this.$refs.daxRef.style.display = "block";
      } else {
        this.$refs.daxRef.style.display = "none";
      }
    },

    checkTitleSetting(titleSetting, event) {
      let data = {
        automatic: (titleSetting == "title_auto" && event) || false,
        comma: (titleSetting == "title_comma" && event) || false,
        semicolon: (titleSetting == "title_semicolon" && event) || false,
      };

      if (!(data.automatic || data.comma || data.semicolon)) {
        data.automatic = true;
      }
      // console.log(data);
      this.settings.setting_title = data;
    },

    onChange(value, $event) {},

    saveDocument() {
      this.$parent.saveDoc(
        null,
        { code: this.code, settings: this.settings },
        "PowerBITheme"
      );
      // this.formatCode();
    },

    updateDocument() {
      this.updateBtnText = "UPDATING...";

      this.$parent.updateDoc(
        this.$route.query.id,
        { code: this.code, settings: this.settings },
        "PowerBITheme"
      );
      setTimeout(() => {
        this.updateBtnText = "UPDATE";
        this.successUpdateMessage = "Document saved!";
        setTimeout(() => {
          this.successUpdateMessage = "";
        }, 2000);
      }, 1000);
      // this.formatCode();
    },

    loadDocument() {
      this.$parent
        .loadDoc(this.$route.query.id)
        .then(({ data }) => {
          this.document = data.doc;
          this.code = data.entity.path;
          this.settings = data.entity.settings;
          // this.formatCode();
          this.readOnly = !this.$parent.checkIfIamAuthor();

          this.showResults = true;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },

    copyToClipboard() {
      this.$copyText(this.code).then((e) => {
        this.copyCodeBtnText = "COPIED";
        // reset to normal after 2 seconds
        setTimeout(() => {
          this.copyCodeBtnText = "COPY CODE";
        }, 2000);
      });
    },

    clone() {
      this.$parent.settingCloneTitle = true;
    },
    newDoc() {
      window.location.href = "/apps/power-bi-theme-generator";
    },

    tabber(event) {
      console.log(event);
      if (event) {
        event.preventDefault();
        let startText = this.chapter.text.slice(0, event.target.selectionStart);
        let endText = this.chapter.text.slice(event.target.selectionStart);
        this.chapter.text = `${startText}\t${endText}`;
        event.target.selectionEnd = event.target.selectionStart + 1;
      }
    },
  },
};
</script>

<style scoped>
.btn-edit-rawcode {
  color: #ffffff;
  background-color: #fa2e05;
  border: 2px solid #fa2e05;
}

.dax-search-code-form .form-control {
  border-left: 5px solid #fa2e05;
  font-family: "Fira Sans", sans-serif;
  color: #a2a2a2;
}

.line-numbers .line-numbers-rows {
  border-right: 5px solid #fa2e05 !important;
  width: 4em !important;
  left: -4.8em !important;
}

.dax-settings-box {
  max-width: 200px;
}

:root {
  touch-action: pan-x pan-y;
  height: 100%;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #a8a8a8;
  opacity: 1; /* Firefox */
  font-weight: bold;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a8a8a8;
  font-weight: bold;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #a8a8a8;
  font-weight: bold;
}

.container-fluid-height {
  min-height: 80vh;
  height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
@media screen and (min-width: 1200px) {
  .container-fluid-height {
    min-height: 65vh;
    height: 65vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}

[v-cloak] {
  display: none !important;
}
:root {
  touch-action: pan-x pan-y;
  height: 100%;
}

pre[class*="language-"].line-numbers {
  padding-bottom: 20px;
}

.bottom-edited-btn {
  width: 120%;
}

@media screen and (min-width: 786px) {
  .bottom-edited-btn {
    margin: auto -60px;
    width: unset;
  }
}
</style>
